import React, { useState } from "react";
import "./TourTypeSection.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import rtour from "../../assets/rtour.png";
import stour from "../../assets/stour.png";
import gtour from "../../assets/gtour.png";
import etour from "../../assets/etour.png";

import wtour from "../../assets/wtour.png";
import ftour from "../../assets/ftour.png";
import fetour from "../../assets/fetour.png";
import htour from "../../assets/htour.png";
import ctour from "../../assets/ctour.png";
import rotour from "../../assets/rotour.png";
/* 🔴 YOUR ORIGINAL DATA — NOT CHANGED */
const tours = [
  {
    id: 1,
    title: "Religious Tour",
    img: rtour,
    desc: "Religious tours offer a deeply spiritual and culturally enriching journey through some of the most sacred destinations. From ancient temples and holy rivers to peaceful monasteries and historic churches, these trips allow travelers to reconnect with faith, tradition, and inner peace. You can witness timeless rituals, participate in ceremonies, and explore architectural wonders that carry centuries of devotion. The calm atmosphere, devotional chants, and spiritual surroundings create a truly meaningful experience. Perfect for families, elders, or anyone seeking tranquility, religious tours combine history, culture, and spirituality into one unforgettable pilgrimage that nourishes both the heart and the soul.",
    link: "/religious-trip",
  },
  {
    id: 2,
    title: "Solo Trip",
    img: stour,
    desc: "A solo trip is the perfect way to discover yourself while exploring the world at your own pace. Traveling alone gives you complete freedom to choose destinations, activities, and schedules without compromise. Whether wandering through mountain trails, relaxing at cozy cafés, or exploring vibrant city streets, every moment becomes personal and memorable. It builds confidence, independence, and  a deeper connection with new cultures and people.Solo travel encourages self- reflection and adventure while allowingspontaneous decisions that often lead to unforgettable experiences.Ideal for explorers seeking growth, peace, and excitement, a solo trip transforms every journey into a powerful story.",
    link: "/solo-trip",
  },
  {
    id: 3,
    title: "Weekend Getaway",
    img: wtour,
    desc: "Weekend getaways are short yet refreshing escapes designed to break the routine of everyday life. Perfect for busy professionals and families, these trips provide relaxation and fun without long travel planning. Spend your days exploring scenic hills, charming towns, beaches, or countryside retreats while enjoying local food and cozy stays. In just two or three days, you can recharge your energy and create beautiful memories with loved ones. Whether it’s adventure activities or peaceful sightseeing, weekend getaways offer the ideal balance of comfort and excitement. They are quick, affordable, and perfect for spontaneous travel lovers.",
    link: "/weekend-getaway-trip",
  },
  {
    id: 4,
    title: "Explore Beach",
    img: etour,
    desc: "Beach tours invite you to unwind beside golden sands, sparkling blue waters, and breathtaking sunsets. Feel the soothing sea breeze as you walk along the shore, swim in crystal-clear water, or relax under swaying palm trees. These trips offer a mix of adventure and leisure with activities like surfing, snorkeling, boat rides, and beach games. Enjoy fresh seafood, coastal culture, and lively nightlife near the sea. Perfect for couples, friends, and families, beach vacations create moments of joy, peace, and fun. A beach tour is the ultimate escape for those seeking sunshine, relaxation, and unforgettable ocean views.",
    link: "/beach-trip",
  },
  {
    id: 5,
    title: "Group Trip",
    img: gtour,
    desc: "Group trips are all about sharing laughter, stories, and unforgettable experiences with friends, family, or colleagues. Traveling together strengthens bonds while creating exciting memories through adventures, sightseeing, and fun activities. From trekking hills and exploring cities to enjoying campfires and games, every moment becomes more enjoyable when shared. Group travel also offers safety, better planning, and cost-effective packages, making it convenient for everyone. With shared meals, group photos, and collective excitement, these trips bring people closer and turn simple journeys into lifelong memories. Perfect for celebrations or reunions, group tours guarantee happiness and togetherness.",
    link: "/group-trip",
  },
  {
    id: 6,
    title: "Honeymoon Trip",
    img: htour,

    desc: "A honeymoon trip is a once in a lifetime celebration of love and new beginnings. Newlyweds enjoy luxurious stays, breathtaking landscapes, private dinners, and romantic experiences tailored just for them. Whether relaxing on tropical beaches or exploring dreamy cities, every detail feels magical. This special journey allows couples to unwind after wedding celebrations, deepen their connection, and start married life with cherished memories in stunning destinations filled with romance and serenity.",
    link: "/honeymoon-trip",
  },
  {
    id: 7,
    title: "Road Trip",
    img: rotour,
    desc: "A road trip is all about freedom, adventure, and spontaneous exploration. Driving through scenic highways, discovering hidden spots, and stopping at charming roadside cafés create unforgettable memories. Whether traveling with friends, family, or a partner, the journey becomes just as exciting as the destination. Music, laughter, and breathtaking landscapes make every mile enjoyable. Road trips encourage bonding, flexibility, and the joy of discovering new experiences along the open road.",
    link: "/road-trip",
  },
  {
    id: 8,
    title: "Couple Trip",
    img: ctour,
    desc: "A couple trip offers the perfect opportunity to reconnect, relax, and create unforgettable memories together. From peaceful beach walks and candlelight dinners to scenic mountain views and cozy resorts, every moment becomes special. Couples can explore charming cities, enjoy private experiences, and escape daily routines. These romantic journeys strengthen bonds, encourage meaningful conversations, and provide beautiful shared adventures in destinations designed for love, comfort, and lasting happiness.",
    link: "/couple-trip",
  },
  {
    id: 9,
    title: "Festival Trip",
    img: fetour,
    desc: "A festival trip immerses travelers in vibrant celebrations filled with color, music, dance, and cultural traditions. Experience lively parades, traditional performances, local cuisine, and joyful gatherings that showcase the spirit of a destination. These trips offer a deeper understanding of heritage and community while creating unforgettable festive memories. Whether celebrating lights, flowers, or music, festival journeys bring excitement, cultural discovery, and happiness to every traveler.",
    link: "/festival-trip",
  },
  {
    id: 10,
    title: "Family Trip",
    img: ftour,
    desc: "A family trip brings everyone together to share laughter, adventure, and meaningful moments. Exploring new destinations, enjoying sightseeing tours, and participating in fun activities strengthen relationships across generations. From theme parks and beaches to cultural attractions and nature retreats, every experience becomes a cherished memory. Family vacations provide relaxation from daily routines while encouraging bonding, communication, and quality time, creating stories that will be remembered and treasured for years.",
    link: "/family-trip",
  },
];

function TourTypeSection() {
  const [active, setActive] = useState(tours[0]);
  const [startIndex, setStartIndex] = useState(0);

  const visibleCount = 6;

  const visibleTours = [
    ...tours.slice(startIndex, startIndex + visibleCount),
    ...tours.slice(0, Math.max(0, startIndex + visibleCount - tours.length)),
  ];

  const handleNext = () => {
    setStartIndex((prev) => (prev + 1) % tours.length);
  };

  const handlePrev = () => {
    setStartIndex((prev) => (prev - 1 + tours.length) % tours.length);
  };
  const navigate = useNavigate();
  return (
    <div className="tour-section">
      <h2 className="tour-heading">Tour Types</h2>

      <div className="tour-main-card">
        <img src={active.img} alt="" onClick={() => navigate(active.link)} />
        <div className="tour-main-content">
          <h3>{active.title}</h3>
          <p>{active.desc}</p>
        </div>
      </div>

      <div className="tour-bottom-row">
        <button className="arrow-left" onClick={handlePrev}>
          ◀
        </button>

        <div className="tour-grid">
          {visibleTours.map((item) => (
            <div
              key={item.id}
              className={`tour-thumb ${active.id === item.id ? "active" : ""}`}
              onClick={() => setActive(item)}
            >
              <img src={item.img} alt="" />
              <span>{item.title}</span>
            </div>
          ))}
        </div>

        <button className="arrow-right" onClick={handleNext}>
          ▶
        </button>
      </div>

      <Link to="/tour-type-view-more">
        <button className="view-more">View More</button>
      </Link>
    </div>
  );
}

export default TourTypeSection;
